import { render, staticRenderFns } from "./Juegos.vue?vue&type=template&id=5149ba65&"
import script from "./Juegos.vue?vue&type=script&lang=js&"
export * from "./Juegos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports